<template>
    <div class="sub-tit">
        <h2>주차</h2>
    </div>
    <div class="tab-menu type02">
        <ul class="tab-menu__list">
            <li class="tab-menu__item on"><a href="/park/parkIntro.do" type="button" class="tab-menu__btn">창원파티마병원 주차등록</a></li>
        </ul>
    </div>
    <div class="parkingRes_wrap">
        <div class="join-tab">
            <ul class="join-tab__list">
                <li class="join-tab__item active">
                    <div class="tit">창원파티마병원 주차등록</div>
                </li>
            </ul>
        </div>

        <div class="certification">
            <ul class="contents login-box__list">
                <li class="login-box__item">
                    <h3 class="tit" style="color: #333;">차량번호 뒤 4자리 입력 후 
                        <span style="color:rgb(203 168 20);">확인</span> 버튼을 눌러주세요.
                    </h3>
                    <p class="desc">입력하신 정보는 주차등록 처리 목적에만 사용됩니다.</p>
                    <div class="parking_num_wrap">
                        <input
                            v-for="(d, i) in digits"
                            :key="i"
                            ref="pinInputs"
                            type="text"
                            inputmode="numeric"
                            maxlength="1"
                            class="pin-digit"
                            v-model="digits[i]"
                            @input="onInput(i)"
                            @keydown.backspace.prevent="onBackspace(i)"
                            @focus="activeIndex = i"
                        />
                    </div>
                    
                    <ul class="num_btn_list">
                        <li class="num_items_top">
                            <button class="num_btn" v-for="n in [1,2,3,4,5]" :key="n" @click="handleNumClick(n)">{{ n }}</button>
                            <button class="num_btn action_btn" style="color:#f6d548;" @click="handleOk">확인</button>
                        </li>
                        <li class="num_items_bottom">
                            <button class="num_btn" v-for="n in [6,7,8,9,0]" :key="n" @click="handleNumClick(n)">{{ n }}</button>
                            <button class="num_btn action_btn" @click="handleDel">취소</button>
                        </li>
                    </ul>


                </li>
            </ul>
        </div>
    </div>
</template>

<script>
const SS_KEY = 'park:list';

export default {
    name: 'ParkingIntro',
    components: {
       
    },
    data() {
        return {
            digits: ['', '', '', ''],
            activeIndex: 0, // 현재 입력칸
            parkTestList: [
                    { car: "111가 1234", time: "2025-09-07 10:30" },
                    { car: "333나 7777", time: "2025-09-07 11:00" },
                    { car: "444다 7777", time: "2025-09-07 11:00" },
                    { car: "555라 7777", time: "2025-09-07 11:00" },
                    { car: "333나 7777", time: "2025-09-07 11:00" },
                    { car: "333나 7777", time: "2025-09-07 11:00" },
                    { car: "333나 7777", time: "2025-09-07 11:00" },
                    { car: "333나 7777", time: "2025-09-07 11:00" },
                    { car: "333나 7777", time: "2025-09-07 11:00" },
                    { car: "333나 7777", time: "2025-09-07 11:00" }
                ],
        };
    },
    mounted() {
       this.focusIndex(0);
    },
    beforeUnmount() {
      
    },
    methods: {
        focusIndex(i) {
            this.$nextTick(() => {
                const el = this.$refs.pinInputs?.[i];
                el && el.focus();
            });
        },
        onInput(i) {
            // 숫자 외 제거
            this.digits[i] = (this.digits[i] || '').replace(/\D/g, '').slice(0, 1);
            // 한 자리 들어오면 다음 칸
            if (this.digits[i]) {
                if (i < 3) {
                    this.activeIndex = i + 1;
                    this.focusIndex(this.activeIndex);
                }
            }
        },
        onBackspace(i) {
            // 현재 칸 비어있으면 이전 칸 지우기
            if (!this.digits[i] && i > 0) {
                this.digits[i - 1] = '';
                this.activeIndex = i - 1;
                this.focusIndex(this.activeIndex);
            } else {
                // 현재 칸만 지우고 포커스 유지
                this.digits[i] = '';
                this.focusIndex(i);
            }
        },
        handleNumClick(n) {
            const i = this.activeIndex;
            if (i > 3) return;
            this.digits[i] = String(n);
            // 다음 칸으로
            if (i < 3) {
                this.activeIndex = i + 1;
                this.focusIndex(this.activeIndex);
            } else {
                this.focusIndex(3);
            }
        },
        handleDel() {
            // 마지막 채워진 칸을 지우는 동작
            let i = this.digits.findLastIndex(v => v !== '');
            if (i === -1) return;
            this.digits[i] = '';
            this.activeIndex = i;
            this.focusIndex(i);
        },
        handleOk() {
            const carno = this.digits.join('');
            if (carno.length !== 4) {
                alert('차량번호 뒤 4자리를 입력해주세요.');
                return;
            }

            
            this.axios.get(this.api.park.search, {
            params: {
                carno: carno,
                macaddr: '' // 필요 시 채워넣기
            }
            })
            .then(({ data }) => {
                const list = Array.isArray(data?.list) ? data.list : [];

                if(list.length === 0){
                    alert('조회된 차량이 없습니다.');
                    return; 
                }

                this.$router.push({
                    path: '/park/parkConfirm.do',
                    state: { list }   // 큰 데이터도 가능(주소창에 안 보임)
                });
                
            })
            .catch(err => {
                console.error(err);
                alert('주차 차량 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            })
            
        },

    },
}
</script>